export const homeObjOne = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  headline: "The classical scheme of cubesats for 3U was chosen. ToySat",
  description:
    "The idea of developing a nanosatellite with a VR camera and the possibility of a remote connection to it, thereby anyone will be able to observe the planet Earth from a height of 550 km and fully immerse themselves in space. And also the thermal imager is able to detect foci of forest fires",
  imgStart: "",
  img: require("../../images/toysat.jpg"),
  alt: "Vault",
};

export const homeObjTwo = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "100% Secure",
  headline: "Stay protected 24/7 anywhere anytime",
  description:
    "We have you covered no matter where you are located. Over 140 locations worldwide to ensure you have access anytime",
  imgStart: "",
  img: require("../../images/svg-1.svg"),
  alt: "Vault",
};

export const homeObjThree = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  headline: "Scheme of Using Machine Learning",
  description:
    "We have used Python and Tensorflow with Keras to learn CNN and calculate Wolf number. The result of process is it will send  15 photos for 30 minutes. Code and DataSet will available on GitHub",
  imgStart: "start",
  img: require("../../images/board.png"),
  alt: "Vault",
};

export const homeObjFour = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Data Analytics",
  headline: "Every transaction is stored on our secure cloud database",
  description:
    "Never ever have to worry again about saved reciepts. We store your data, so you can access it anytime.",
  buttonLabel: "Sign Up Now",
  imgStart: "start",
  img: require("../../images/svg-1.svg"),
  alt: "Vault",
};
